document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('[data-search-drawer]');
  if (!drawer) return;

  var backdrop = drawer.querySelector('[data-search-drawer-backdrop]');
  var closeButton = drawer.querySelector('[data-search-drawer-close]');
  var input = drawer.querySelector('[data-search-drawer-input]');
  var resultsContainer = drawer.querySelector('[data-search-drawer-results]');
  var triggers = document.querySelectorAll('[data-search-drawer-trigger]');

  var predictiveSearchUrl = drawer.getAttribute('data-predictive-search-url');
  var searchUrl = drawer.getAttribute('data-search-url');
  var noResultsText = drawer.getAttribute('data-no-results-text') || 'No results found';
  var viewAllText = drawer.getAttribute('data-view-all-text') || 'Search for';
  var loadingText = drawer.getAttribute('data-loading-text') || 'Loading';

  var debounceTimer = null;
  var latestRequestId = 0;

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function appendUrlParam(url, param) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + param;
  }

  function formatMoney(amount) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var value = parseFloat(amount);
    if (isNaN(value)) return amount;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(value);
    } catch (e) {
      return amount;
    }
  }

  function openDrawer() {
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    window.requestAnimationFrame(function () {
      input.focus();
    });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      drawer.hidden = true;
    }, 250);
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openDrawer();
    });
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }
  if (backdrop) {
    backdrop.addEventListener('click', closeDrawer);
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !drawer.hidden) {
      closeDrawer();
    }
  });

  function renderResults(products, query) {
    if (!products.length) {
      resultsContainer.innerHTML =
        '<p class="site-search-drawer__status">' + noResultsText + '</p>';
      return;
    }

    var html = products
      .map(function (product) {
        var image = product.image
          ? '<img src="' + escapeHtml(appendUrlParam(product.image, 'width=96')) + '" alt="" loading="lazy" width="48" height="48">'
          : '';
        return (
          '<a class="site-search-drawer__result" href="' + escapeHtml(product.url) + '">' +
          '<span class="site-search-drawer__result-image">' + image + '</span>' +
          '<span>' +
          '<p class="site-search-drawer__result-title">' + escapeHtml(product.title) + '</p>' +
          '<p class="site-search-drawer__result-price">' + escapeHtml(formatMoney(product.price)) + '</p>' +
          '</span>' +
          '</a>'
        );
      })
      .join('');

    // "View all results" link disabled until /search results page is styled.
    // html +=
    //   '<a class="site-search-drawer__view-all" href="' +
    //   escapeHtml(appendUrlParam(searchUrl, 'q=' + encodeURIComponent(query))) +
    //   '">' +
    //   escapeHtml(viewAllText) +
    //   ' &ldquo;' +
    //   escapeHtml(query) +
    //   '&rdquo;</a>';

    resultsContainer.innerHTML = html;
  }

  function fetchResults(query) {
    var requestId = ++latestRequestId;
    resultsContainer.innerHTML =
      '<p class="site-search-drawer__status">' + loadingText + '&hellip;</p>';

    var url =
      predictiveSearchUrl +
      '.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (requestId !== latestRequestId) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, query);
      })
      .catch(function () {
        if (requestId !== latestRequestId) return;
        resultsContainer.innerHTML =
          '<p class="site-search-drawer__status">' + noResultsText + '</p>';
      });
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();

    window.clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      return;
    }

    debounceTimer = window.setTimeout(function () {
      fetchResults(query);
    }, 250);
  });
});
